import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

export const managerActionRecall = createAsyncThunk(
  "managerActionRecall/recall",
  async ({ projectid, personid }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${BackendURL}/managerProjectRequested/update-task-status`,
        { projectid, personid }
      );
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Failed to recall manager action"
      );
    }
  }
);

const managerActionRecallSlice = createSlice({
  name: "managerActionRecall",
  initialState: {
    loading: false,
    success: false,
    message: "",
    error: null,
  },
  reducers: {
    resetManagerActionRecall(state) {
      state.loading = false;
      state.success = false;
      state.message = "";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // 🔄 Pending
      .addCase(managerActionRecall.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })

      // ✅ Fulfilled
      .addCase(managerActionRecall.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload?.message || "Recall successful";
      })

      // ❌ Rejected
      .addCase(managerActionRecall.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetManagerActionRecall } =
  managerActionRecallSlice.actions;

export default managerActionRecallSlice.reducer;
